import { GetBilling } from 'domain/usecases/billing/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteGetBilling implements GetBilling {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetBilling.Model>;

  constructor(url: string, httClient: HttpClient<GetBilling.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (params: GetBilling.Params): Promise<GetBilling.Model> => {
    let query = '';

    Object.entries(params.query).forEach(([key, value]) => {
      if (value) query += `${key}=${value}&`;
    });

    const httpResponse = await this.httpClient.request({
      url: `${this.url.replace('{orgId}', `${params.orgId}`)}?${query}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
      case HttpStatusCode.notModified:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
